import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewDynamicField from "../../components/DynamicField/ViewDynamicFieldPage";

const ViewDynamicFieldPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          id="title"
          title2="Preferences"
          link2="/preferences"
          title="View Preference"
        />
        <ViewDynamicField />
      </MasterLayout>
    </>
  );
};

export default ViewDynamicFieldPage;
